"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
require("./style.scss");
const Grid = (props) => {
    const commonState = (0, react_redux_1.useSelector)((state) => (Object.assign({}, state.common)));
    const { sidebarStatus } = commonState;
    const handleOnClick = (event) => {
        const element = event.target;
        if (element.getAttribute('data-stop-prop'))
            return;
        if (onClick)
            onClick(event);
    };
    const { className = '', children, onClick, row = false, col = false, xs, sm, md, lg, xl, xxl } = props;
    const gridRow = row ? 'grid__row' : '';
    const gridCol = col ? 'grid__col' : '';
    const menuStatus = sidebarStatus.isOpen ? 'sidebarOpen' : '';
    const colXs = xs ? `grid__colxs_${xs}` : '';
    const colSm = xs ? `grid__colsm_${sm}` : '';
    const colMd = xs ? `grid__colmd_${md}` : '';
    const colLg = xs ? `grid__collg_${lg}` : '';
    const colXl = xs ? `grid__colxl_${xl}` : '';
    const colXxl = xs ? `grid__colxxl_${xxl}` : '';
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ onClick: handleOnClick, className: `${gridRow} ${gridCol} ${colXs} ${colSm} ${colMd} ${colLg} ${colXl} ${colXxl} ${menuStatus} ${className}` }, { children: children })));
};
exports.default = Grid;
